import { Sun, Moon } from 'lucide-react';
import { useThemeContext } from './ThemeProvider';
import { useToast } from '../hooks/useToast';

export function ThemeToggle() {
  const { resolvedTheme, toggleTheme } = useThemeContext();
  const { success } = useToast();
  const isDark = resolvedTheme === 'dark';

  return (
    <button
      type="button"
      onClick={() => {
        toggleTheme();
        success(isDark ? 'Switched to light mode' : 'Switched to dark mode');
      }}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '36px',
        height: '36px',
        borderRadius: '12px',
        border: 'none',
        background: 'transparent',
        color: isDark ? '#fde68a' : '#f59e0b',
        cursor: 'pointer',
        transition: 'background 0.15s',
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLButtonElement).style.background = isDark
          ? 'rgba(255,255,255,0.08)'
          : 'rgba(0,0,0,0.06)';
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
      }}
    >
      {isDark ? <Moon size={18} /> : <Sun size={18} />}
    </button>
  );
}
